import { render } from "./ResidentialApartmentsList.vue?vue&type=template&id=469bdf67&scoped=true"
import script from "./ResidentialApartmentsList.vue?vue&type=script&lang=js"
export * from "./ResidentialApartmentsList.vue?vue&type=script&lang=js"

import "./ResidentialApartmentsList.vue?vue&type=style&index=0&id=469bdf67&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469bdf67"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QIcon});
